define.alias("shared/components/shared/profile-categorization/banner", "settings/components/shared/profile-categorization/banner");